module.exports = __webpack_public_path__ + "static/media/ic_check_primary.41fa0818.svg";